const getters = {
  lang: state => state.lang.lang,
  status: state => state.account.status,
  time: state => state.expireTime.time
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js